import React from 'react';
import { Dropdown } from 'ui-builder';
import { MarketRequestStatus } from 'nekst-api';

export function MarketRequestStatusDropdown() {
  return (
    <Dropdown
      options={[
        {
          label: 'In Progress',
          value: MarketRequestStatus.IN_PROGRESS,
        },
        {
          label: 'Processed',
          value: MarketRequestStatus.PROCESSED
        }
      ]}
      source="status"
    />
  );
}
